var React = require('react');

function ExternalLink (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M40.04 6h-8.59c-.82 0-1.5-.67-1.49-1.5 0-.83.67-1.5 1.5-1.5h12.2a1.47 1.47 0 01.6.13c.17.07.32.17.46.31a1.29 1.29 0 01.315.47 1.47 1.47 0 01.125.59v12.21a1.505 1.505 0 01-1.5 1.5c-.83 0-1.5-.67-1.5-1.5V8.12L25.37 24.91c-.58.59-1.53.59-2.12 0a1.49 1.49 0 010-2.12L40.04 6z","key":0}),React.createElement("path",{"d":"M42.15 27.35c0-.83.67-1.5 1.5-1.5s1.5.68 1.5 1.5v15.32a2.5 2.5 0 01-2.5 2.5H5.5a2.5 2.5 0 01-2.5-2.5V5.52a2.5 2.5 0 012.5-2.5h16.58c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5H6v36.14h36.15V27.35z","key":1})]);
}

ExternalLink.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = ExternalLink;

ExternalLink.default = ExternalLink;
